export default __webpack_public_path__ + "static/media/kitchen-3.17595af2.jpg";